const UTM = [
  { param: "utm_source", key: "utmSource" },
  { param: "utm_medium", key: "utmMedium" },
  { param: "utm_campaign", key: "utmCampaign" },
  { param: "utm_term", key: "utmTerm" },
  { param: "utm_content", key: "utmContent" },
]

export function initUtm (options) {
  const urlParams = new URLSearchParams(window.location.search)
  const urlUtm = {}

  UTM.map(item => [ item.param, item.key ]).forEach(([ param, key ]) => {
    if (!urlParams.has(param)) {
      return
    }

    urlUtm[key] = urlParams.get(param)
  })

  const urlHasUtm = (Object.keys(urlUtm).length > 0)

  if (urlHasUtm) {
    sessionStorage.setItem("utm", JSON.stringify(urlUtm))
  }

  const utm = JSON.parse(sessionStorage.getItem("utm"))

  console.debug("utm", utm)

  if (!utm) {
    return
  }

  document.addEventListener("DOMContentLoaded", () => {
    UTM.map(item => item.key).forEach(key => {
      if (!(key in utm)) {
        return
      }

      const field = document.createElement("input")
      field.type = "hidden"
      field.name = key
      field.value = utm[key]

      options.form.prepend(field)
    })
  })
}
